import { Button, Collapse, Divider, Modal, Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	WarningMessageBox,
	InfoMessageBox
} from "../../components/styled/common";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useBannerMobileContext } from "../../context/BannerMobileContext/BannerMobileContext";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getBannerMobileItems } from "./constants";

const EditBannerMobile = () => {
	const { id } = useParams<{ id: string }>();
	const { updateBannerMobile, operationStatus, getBannerMobileDetails, bannerMobileDetail, setBannerMobileForm } = useBannerMobileContext();
	const [hasNavigation, setHasNavigation] = useState<boolean | undefined>(bannerMobileDetail?.hasNavigation);
	const [isNavigationModalVisible, setIsNavigationModalVisible] = useState(false);
	const [isUpper, setIsUpper] = useState<boolean | undefined>(bannerMobileDetail?.isUpper);
	const [isUpperModalVisible, setIsUpperModalVisible] = useState(false);

	useEffect(() => {
		if (id) {
			getBannerMobileDetails(id);
		}
	}, [id]);

	useEffect(() => {
		setHasNavigation(bannerMobileDetail?.hasNavigation);
		setIsUpper(bannerMobileDetail?.isUpper);
	}, [bannerMobileDetail]);

	const handleHasNavigationChange = (checked: boolean) => {
		const isNavigationBeingDisabled = hasNavigation === true && checked === false;

		if (isNavigationBeingDisabled) {
			setIsNavigationModalVisible(true);
			return;
		}

		setHasNavigation(checked);
		setBannerMobileForm(prevState => ({ ...prevState, hasNavigation: checked }));
	};

	const handleDisableNavigationConfirm = () => {
		setHasNavigation(false);
		setBannerMobileForm(prevState => ({
			...prevState,
			hasNavigation: false,
			bannerMobileLocalizable: prevState.bannerMobileLocalizable.map(localizable => ({
				...localizable,
				url: "",
			})),
		}));
		setIsNavigationModalVisible(false);
	};

	const handleIsUpperChange = (checked: boolean) => {
		const isUpperBeingChanged = checked !== bannerMobileDetail?.isUpper;

		if (isUpperBeingChanged) {
			setIsUpperModalVisible(true);
			return;
		}

		setIsUpper(checked);
		setBannerMobileForm(prevState => ({ ...prevState, isUpper: checked }));
	};

	const handleIsUpperConfirm = () => {
		setIsUpper(!isUpper);
		setBannerMobileForm(prevState => ({ ...prevState, isUpper: !isUpper }));
		setIsUpperModalVisible(false);
	};

	const bannerMobileItems = getBannerMobileItems({
		hasNavigation,
		onHasNavigationChange: handleHasNavigationChange,
		isUpper,
		onIsUpperChange: handleIsUpperChange,
	});

	return (
		<ActionContainer>
			<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
				<ActionItemsContainer>
					<>
						<h3>Mobil Banner Güncelle</h3>
						<Divider />
						<Collapse
							items={bannerMobileItems}
							expandIconPosition="end"
							bordered={false}
							ghost
							expandIcon={CollapseExpandIcon}
							defaultActiveKey={["1", "2", "3", "4"]}
						/>
					</>
					<SubmitButtonOverlay>
						<MainButtonComponent onClick={updateBannerMobile} type="default" loading={operationStatus.type === "loading" && operationStatus.operation === "update"}>
							Güncelle
						</MainButtonComponent>
					</SubmitButtonOverlay>
				</ActionItemsContainer>
				<Modal
					title="Yönlendirme kapatılsın mı?"
					open={isNavigationModalVisible}
					onCancel={() => setIsNavigationModalVisible(false)}
					centered
					footer={[
						<Button key="cancel" type="text" onClick={() => setIsNavigationModalVisible(false)}>
							Vazgeç
						</Button>,
						<Button key="confirm" type="primary" danger onClick={handleDisableNavigationConfirm}>
							Evet
						</Button>,
					]}
				>
					<p>Bu banner için yönlendirmeyi kapatmak istediğinizden emin misiniz?</p>
					<WarningMessageBox>Yönlendirme kapatılırsa, form gönderimi sonrası, tüm URL alanları temizlenecektir. Bu işlem geri alınamaz.</WarningMessageBox>
				</Modal>
				<Modal
					title="Banner Konumu Değiştirilsin mi?"
					open={isUpperModalVisible}
					onCancel={() => setIsUpperModalVisible(false)}
					centered
					footer={[
						<Button key="cancel" type="text" onClick={() => setIsUpperModalVisible(false)}>
							Vazgeç
						</Button>,
						<Button key="confirm" type="primary" danger onClick={handleIsUpperConfirm}>
							Evet
						</Button>,
					]}
				>
					<p>Bu bannerın konumunu değiştirmek istediğinizden emin misiniz?</p>
					<InfoMessageBox>Konum değiştirildiğinde, resim girdisi verilmesi gerekmektedir. Eğer başlık ve diğer alanların sabit kalmasını istiyorsanız, lütfen sadece istenen boyuttaki resmi yükleyip güncelleyin.</InfoMessageBox>
				</Modal>
			</Spin>
		</ActionContainer>
	);
};

export default EditBannerMobile;
